import React, {PropTypes} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// SHARED
import muiTheme from '../../utils/muiTheme'
import BackNavLink from '../../core/components/BackNavLink'
import { FieldGroup } from '../../core/components/FieldGroup';
import { Slider, Select, Button, Col, Row } from 'antd';
import Card, { TitleCard, CardHeader } from '../../core/Card'
import Line from '../../core/Line'
// LOCAL
import AddMemberForm from './AddMemberForm'
import './NewMainContent.css'


const NewMainContent = ({invited,user, ui, onCreateMemberInvitesFormReset, showCheckmark, handleSubmit, handleFocus}) => {
    // TODO flatten and move shareLink to reducer
    // enterprise.shareLink
    const shareLink = user.group_as_enterprise_owner && (user.group_as_enterprise_owner.join_link)

    return (
      <div className="NewMainContent">
      <TitleCard showBackButton>
        <h1>Add New Member(s)</h1>
      </TitleCard>

      <Card>
        {/* <CardHeader
          title="Add Members"
        /> */}
        <Row className="show-grid">
          <Col xs={24} sm={24} md={24}>
              <h3 className="column-title">Add enterprise members by entering emails</h3>
              <p className="column-title-subcopy">Please separate multiple emails with a comma or a new line.</p>

              <MuiThemeProvider muiTheme={muiTheme}>
                <AddMemberForm
                  showCheckmark={showCheckmark}
                  onSubmit={handleSubmit}
                />
              </MuiThemeProvider>

          </Col>
        </Row>
        <Row className="show-grid">
          <Col xs={24} sm={24} md={24}>

            <p className="full-width-center-text">or</p>

          </Col>
        </Row>
        <Row className="show-grid">
          <Col xs={24} sm={24} md={24}>

            <h3 className="column-title">Share your unique link with your members</h3>
            <p className="column-title-subcopy">Copy/paste the link below. When your members sign up through this link we'll connect them to you.</p>
            <FieldGroup
              readOnly
              onFocus={handleFocus}
              id="formControlsText"
              type="text"
              value={shareLink}
            />
          </Col>
        </Row>
      </Card>

      </div>
    );
  }

NewMainContent.propTypes = {
};

export default NewMainContent



// WEBPACK FOOTER //
// ./src/enterprise/members/NewMainContent.js